'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _animejs = require('animejs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Giftbox = function () {
  function Giftbox() {
    (0, _classCallCheck3.default)(this, Giftbox);

    this.element;
    this.selectedProducts = {};
    this.init();
  }

  (0, _createClass3.default)(Giftbox, [{
    key: 'getElement',
    value: function getElement() {
      return this.element;
    }
  }, {
    key: 'getSelectedProducts',
    value: function getSelectedProducts() {
      var properties = {};
      var keys = Object.keys(this.selectedProducts).sort(function (a, b) {
        return a - b;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var label = this.selectedProducts[key].label;

          properties[key] = label;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.selectedProducts.Note) {
        properties.Note = this.selectedProducts.Note;
      }
      return properties;
    }
  }, {
    key: 'showCorrectGiftOptions',
    value: function showCorrectGiftOptions(setting) {
      var element = this.getElement();
      var options = [].concat((0, _toConsumableArray3.default)(element.querySelectorAll('.js-step2Select')));

      this.selectedProducts = {};
      this.clearSelectedProducts();

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = options[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;

          option.value = '';
          option.style.display = 'none';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (setting === 'Tea') {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = options[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _option = _step3.value;

            if (_option.dataset.type === 'Tea') {
              _option.style.display = 'block';
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      if (setting === 'Mix') {
        var teaCount = 0;
        var coffeeCount = 0;

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = options[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _option2 = _step4.value;

            if (_option2.dataset.type === 'Tea' && teaCount < 2) {
              _option2.style.display = 'block';
              teaCount++;
            }
            if (_option2.dataset.type === 'Coffee' && coffeeCount < 1) {
              _option2.style.display = 'block';
              coffeeCount++;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      if (setting === 'Coffee') {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = options[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _option3 = _step5.value;

            if (_option3.dataset.type === 'Coffee') {
              _option3.style.display = 'block';
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    }
  }, {
    key: 'clearSelectedProducts',
    value: function clearSelectedProducts() {
      var element = this.getElement();
      var selection = element.querySelector('.js-selection');
      var child = selection.lastElementChild;
      while (child) {
        selection.removeChild(child);
        child = selection.lastElementChild;
      }
    }
  }, {
    key: 'showCorrectSelectedProducts',
    value: function showCorrectSelectedProducts() {
      this.clearSelectedProducts();

      var element = this.getElement();
      var items = [].concat((0, _toConsumableArray3.default)(element.querySelectorAll('.js-giftProductSelection')));
      var step2Selects = element.querySelectorAll('.js-step2Select');
      var selection = element.querySelector('.js-selection');

      var _loop = function _loop(select) {
        if (select.value !== '') {
          var image = items.find(function (item) {
            return item.dataset.id == select.value;
          });
          var newImage = document.createElement('img');
          newImage.src = image.dataset.src;
          selection.append(newImage);
        }
      };

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = step2Selects[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var select = _step6.value;

          _loop(select);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      var element = document.querySelector('.js-giftForm');
      if (element) {
        this.element = element;

        var step1select = element.querySelector('.js-step1Select');
        step1select.value = 'Tea';
        step1select.addEventListener('change', function () {
          _this.showCorrectGiftOptions(step1select.value);
          _this.disableAddToCart();
        });

        var step2Selects = element.querySelectorAll('.js-step2Select');

        var _loop2 = function _loop2(step2Select) {
          step2Select.addEventListener('change', function () {
            var label = step2Select.options[step2Select.selectedIndex].text;
            var name = step2Select.getAttribute('name');
            var id = step2Select.value;
            _this.selectedProducts[name] = {
              id: id,
              label: label
            };
            if (id === '') {
              delete _this.selectedProducts[name];
            }

            _this.showCorrectSelectedProducts();
            _this.checkAddToCart();
          });
        };

        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = step2Selects[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var step2Select = _step7.value;

            _loop2(step2Select);
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        var step3Note = element.querySelector('.js-step3Note');
        step3Note.value = '';
        step3Note.addEventListener('keyup', function () {
          _this.selectedProducts.Note = step3Note.value;
        });

        this.showCorrectGiftOptions('Tea');
        this.disableAddToCart();
      }
    }
  }, {
    key: 'checkAddToCart',
    value: function checkAddToCart() {
      var element = this.getElement();
      var step2Selects = element.querySelectorAll('.js-step2Select');

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = step2Selects[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var select = _step8.value;

          var style = getComputedStyle(select);
          if (style.display == 'block' && select.value === '') {
            this.disableAddToCart();
            return;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      this.enableAddToCart();
    }
  }, {
    key: 'disableAddToCart',
    value: function disableAddToCart() {
      var addToCart = document.querySelector('.js-submit');
      addToCart.textContent = 'Select Gift Box Items';
      addToCart.setAttribute('disabled', true);
    }
  }, {
    key: 'enableAddToCart',
    value: function enableAddToCart() {
      var addToCart = document.querySelector('.js-submit');
      addToCart.textContent = 'Add To Cart';
      addToCart.removeAttribute('disabled');
    }
  }]);
  return Giftbox;
}();

exports.default = Giftbox;